"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  StoredFilesProvider,
  useNextRouter,
} from "@shesha-io/reactjs";
import { AppProgressBar } from "next-nprogress-bar";
import { WorkflowApplicationPlugin } from "@shesha-io/workflow";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
import { HcmApplicationPlugin } from "@shesha-io/hcm";
import { useTheme } from "antd-style";
import { CURRENT_APPOINTMENT_HEADER } from "@/routing";
import './styles-quickfix.css';

export interface IAppProviderProps {
  backendUrl: string;
  positionAppointmentId?: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
  positionAppointmentId,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={nextRouter.path?.includes('/no-auth')}
        buildHttpRequestHeaders={() => {
          return { [CURRENT_APPOINTMENT_HEADER]: positionAppointmentId };
        }}
      >
        <EnterpriseApplicationPlugin>
          <WorkflowApplicationPlugin>
            <HcmApplicationPlugin>
              <StoredFilesProvider baseUrl={backendUrl} ownerId={""} ownerType={""}>
                {children}
              </StoredFilesProvider>
            </HcmApplicationPlugin>
          </WorkflowApplicationPlugin>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
